import { render, staticRenderFns } from "./ReviseMenu.vue?vue&type=template&id=79564d32&"
import script from "./ReviseMenu.vue?vue&type=script&lang=js&"
export * from "./ReviseMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports